import React from 'react';
import { string } from 'prop-types';

const MapIcon = ({ alt, className, src }) => {
  return (
    <img
      alt={alt ? alt : 'map icon'}
      className={className ? className : 'google-maps-marker'}
      src={src && src}
    />
  );
};

MapIcon.propTypes = {
  alt: string,
  className: string,
  src: string
};

export default MapIcon;
